import { useSelector } from 'react-redux';
import { price } from 'utils/helpers';
import PaymentSurcharge from 'components/checkout_form/payment_surcharge';
import { getSurchargeAmount } from 'redux/selectors/current_booking';

function Surcharge() {
  const surchargeAmount = useSelector(getSurchargeAmount);

  if (!surchargeAmount) {
    return null;
  }

  return (
    <div className="summary-card__surcharge space-y-2 text-small">
      <PaymentSurcharge className="text-small" />
      <div className="summary-card__flex-item text-small">
        <div>Surcharge applied: </div>
        <div>{price(surchargeAmount)}</div>
      </div>
    </div>
  );
}

export default Surcharge;
